import { Breadcrumbs } from "@mui/material";
import { styled } from "@mui/system";

export const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  "& .MuiBreadcrumbs-separator": {
    display: "none",
  },
}));
